"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Downloader = void 0;
exports.createUrl = createUrl;
exports.createBlob = createBlob;
const React = __importStar(require("react"));
class Downloader extends React.Component {
    constructor(props) {
        super(props);
        this.download = () => {
            if (!!window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(this.state.blob, this.props.fileName);
                return;
            }
            if (this.anchorElement) {
                this.anchorElement.click();
            }
        };
        const blob = createBlob(props.data);
        const newUrl = blob ? createUrl(blob) : undefined;
        this.state = {
            url: newUrl,
            blob: blob
        };
    }
    componentWillReceiveProps(nextProps) {
        const url = this.state.url;
        if (url !== undefined) {
            URL.revokeObjectURL(url);
        }
        const blob = createBlob(nextProps.data);
        const newUrl = blob ? createUrl(blob) : undefined;
        this.setState(() => ({
            url: newUrl,
            blob: blob
        }));
    }
    componentDidUpdate() {
        if (!this.props.data) {
            this.download();
        }
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("a", { style: { display: "none" }, ref: el => {
                    this.anchorElement = el;
                }, href: this.state.url, download: this.props.fileName }),
            this.props.children(() => {
                this.download();
            })));
    }
}
exports.Downloader = Downloader;
function createUrl(blob) {
    return URL.createObjectURL(blob);
}
function createBlob(data) {
    if (data === undefined) {
        return undefined;
    }
    const blob = new Blob([data]);
    return blob;
}
//# sourceMappingURL=downloader.js.map